(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initialiseProductFinder = (scope = document) => {
    scope.querySelectorAll('[data-product-finder]').forEach((finder) => {
      if (finder.dataset.ready === 'true') return;
      finder.dataset.ready = 'true';
      const filterSets = Array.from(finder.querySelectorAll('[data-filter-set]'));
      const cards = Array.from(finder.querySelectorAll('[data-product-card]'));
      const grid = finder.querySelector('[data-product-grid]');
      const count = finder.querySelector('[data-result-count]');
      const empty = finder.querySelector('[data-filter-empty]');
      const clear = finder.querySelector('[data-clear-filters]');
      const activeCount = finder.querySelector('[data-active-count]');
      const selection = {};
      const flagship = cards.find((card) => card.querySelector('.collection-card__badge'));
      if (grid && flagship) grid.prepend(flagship);
      filterSets.forEach((set) => { selection[set.dataset.filterSet] = 'all'; });

      const updateResults = () => {
        let visible = 0;
        cards.forEach((card) => {
          const matches = Object.entries(selection).every(([group, value]) => {
            if (value === 'all') return true;
            return (card.dataset[group] || '').split(' ').includes(value);
          });
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (count) count.textContent = `${visible} ${count.dataset.label}`;
        const selectedCount = Object.values(selection).filter((value) => value !== 'all').length;
        if (activeCount) {
          activeCount.textContent = `${selectedCount} ${activeCount.dataset.label}`;
          activeCount.hidden = selectedCount === 0;
        }
        if (clear) clear.hidden = selectedCount === 0;
        if (empty) empty.hidden = visible !== 0;
      };

      filterSets.forEach((set) => {
        set.querySelectorAll('button[data-filter-value]').forEach((button) => {
          button.addEventListener('click', () => {
            selection[set.dataset.filterSet] = button.dataset.filterValue;
            set.querySelectorAll('button[data-filter-value]').forEach((candidate) => {
              const active = candidate === button;
              candidate.classList.toggle('is-active', active);
              candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            updateResults();
          });
        });
      });

      if (clear) {
        clear.addEventListener('click', () => {
          filterSets.forEach((set) => {
            selection[set.dataset.filterSet] = 'all';
            set.querySelectorAll('button[data-filter-value]').forEach((button) => {
              const active = button.dataset.filterValue === 'all';
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          });
          updateResults();
        });
      }

      updateResults();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseProductFinder());
  else initialiseProductFinder();
  document.addEventListener('shopify:section:load', (event) => initialiseProductFinder(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initialiseMegaMenu = (scope = document) => {
    scope.querySelectorAll('[data-mega-menu]').forEach((menu) => {
      if (menu.dataset.ready === 'true') return;
      menu.dataset.ready = 'true';
      document.addEventListener('click', (event) => {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.removeAttribute('open');
          menu.querySelector('summary')?.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseMegaMenu());
  else initialiseMegaMenu();
  document.addEventListener('shopify:section:load', (event) => initialiseMegaMenu(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const initialiseProductAnchorNavigation = (scope = document) => {
    scope.querySelectorAll('.product-anchor-nav').forEach((navigation) => {
      if (navigation.dataset.ready === 'true') return;
      navigation.dataset.ready = 'true';
      const links = Array.from(navigation.querySelectorAll('a[href^="#"]'));
      const sections = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);
      if (!sections.length) return;
      const updateNavigation = () => {
        const threshold = navigation.offsetHeight + 28;
        let current = sections[0];
        sections.forEach((section) => {
          if (section.getBoundingClientRect().top <= threshold) current = section;
        });
        links.forEach((link) => {
          const isCurrent = link.getAttribute('href') === `#${current.id}`;
          if (isCurrent) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      updateNavigation();
      document.addEventListener('scroll', updateNavigation, { passive: true });
    });
  };

  const initialiseProductLeadContext = (scope = document) => {
    scope.querySelectorAll('.product-inquiry__form').forEach((form) => {
      if (form.dataset.contextReady === 'true') return;
      form.dataset.contextReady = 'true';
      const params = new URLSearchParams(window.location.search);
      const values = {
        referrer: document.referrer,
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign')
      };
      Object.entries(values).forEach(([key, value]) => {
        const input = form.querySelector(`[data-product-lead-context="${key}"]`);
        if (!input || !value) return;
        input.value = value;
        input.disabled = false;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseProductAnchorNavigation();
      initialiseProductLeadContext();
    });
  } else {
    initialiseProductAnchorNavigation();
    initialiseProductLeadContext();
  }
  document.addEventListener('shopify:section:load', (event) => {
    initialiseProductAnchorNavigation(event.target);
    initialiseProductLeadContext(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zetrino-contact"]) return;
  try {
    
  const initialiseContactLeadContext = (scope = document) => {
    scope.querySelectorAll('.contact-form').forEach((form) => {
      if (form.dataset.contextReady === 'true') return;
      form.dataset.contextReady = 'true';
      const params = new URLSearchParams(window.location.search);
      const values = {
        referrer: document.referrer,
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign')
      };
      Object.entries(values).forEach(([key, value]) => {
        const input = form.querySelector(`[data-lead-context="${key}"]`);
        if (!input || !value) return;
        input.value = value;
        input.disabled = false;
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseContactLeadContext());
  else initialiseContactLeadContext();
  document.addEventListener('shopify:section:load', (event) => initialiseContactLeadContext(event.target));

  } catch(e) { console.error(e); }
})();
})();
